import { ReducersTypes } from "constants/ReducersTypes";
import { languageFileMapping } from "utils/localization/config";
import { setReducerData } from "utils";
import {
  dismissApplicationAnnouncement,
  isApplicationAnnouncementDismissed,
} from "utils/applicationAnnouncementStorage";
import { getActiveApplicationAnnouncement } from "containers/support/api";
import { instanceWithRetry, isDifferentCurrency } from "./axiosInstance";

export function navigateWithFilter(to, filter_name, filters, e) {
  e && e.stopPropagation();
  localStorage.setItem(filter_name, JSON.stringify(filters));
  window.open(to, "_self");
}

export const demoFunction = (data) => ({
  type: "ReducersTypes.CONST",
  payload: data,
});

export const setNavigation = (data) => ({
  type: ReducersTypes.NAVIGATION,
  payload: data,
});

export const refreshHeader = () => ({
  type: ReducersTypes.HEADER_REFRESH_TOGGLE,
});

export const fetchActiveApplicationAnnouncement = () => async (dispatch) => {
  try {
    const announcement = await getActiveApplicationAnnouncement();
    dispatch({
      type: ReducersTypes.SET_ACTIVE_APPLICATION_ANNOUNCEMENT,
      payload:
        announcement && !isApplicationAnnouncementDismissed(announcement.id)
          ? announcement
          : null,
    });
  } catch (_error) {
    dispatch({
      type: ReducersTypes.SET_ACTIVE_APPLICATION_ANNOUNCEMENT,
      payload: null,
    });
  }
};

export const dismissActiveApplicationAnnouncement =
  (announcementId) => (dispatch) => {
    dismissApplicationAnnouncement(announcementId);
    dispatch({
      type: ReducersTypes.SET_ACTIVE_APPLICATION_ANNOUNCEMENT,
      payload: null,
    });
  };

export const sendExportedReport = (requestObject) => {
  const updatedReqObj = isDifferentCurrency
    ? { ...requestObject, use_foreign_keys: 1 }
    : requestObject;
  return instanceWithRetry.post("exportdata?mutate=1", updatedReqObj);
};

export const getLocaleJson =
  (locale = "en") =>
  (dispatch) => {
    const fileName = languageFileMapping[locale] ?? languageFileMapping["en"];
    return instanceWithRetry
      .get(`/get_locale_json?locale=${fileName}`)
      .then((res) => {
        dispatch(
          setReducerData(ReducersTypes.SET_TRANSLATION, res?.data?.result)
        );
        return res?.data?.result;
      });
  };
